import { LoadingDefault } from './loading-default';

export default LoadingDefault;
export const Loading = LoadingDefault;
export * from './loading-default';
